import React from "react";

function Badge({ text }) {
	return (
		<>
			<span className="skill-badge">{text}</span>
		</>
	);
}

export default Badge;
